import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';
import Disclaimers from '../Disclaimers';

import usePrequal from '../../resources/prequal/usePrequal';
import useCreateDecision from '../../resources/decision/create';

const GenerateDecision = () => {
  useRUMView('decisioning');

  // Uses session storage to determine if the userInformationOutcome or the
  // pendingOutcome mock should be used. The API defaults to pendingOutcome.
  const isPendingMock = sessionStorage.getItem('isPendingMock');
  useEffect(() => { sessionStorage.setItem('isPendingMock', 'true'); }, []);

  const { data: prequal, mutate: mutatePrequal } = usePrequal();
  const {
    trigger: createDecision,
  } = useCreateDecision(prequal.id, { onSuccess: () => mutatePrequal() });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    createDecision({
      data: prequal,
      outcome: isPendingMock
        ? params.get('pendingOutcome')
        : params.get('userInformationOutcome'),
    });
  }, [createDecision, prequal, isPendingMock]);

  return (
    <Screen
      header="Reviewing your information to determine a decision."
      subheader="A decision will be provided in a few moments."
    >
      <CircularProgress />
      <Disclaimers textAlign="center">
        Do not click the back button or close your browser
        while your information is being processed.
      </Disclaimers>
    </Screen>
  );
};

export default GenerateDecision;
